import React, { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

/**
 * Shows a small floating pill in the corner whenever the browser is offline.
 * Also briefly announces when connection is restored.
 */
export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine !== false);
  const [justCameBack, setJustCameBack] = useState(false);

  useEffect(() => {
    const on = () => { setOnline(true); setJustCameBack(true); setTimeout(() => setJustCameBack(false), 2500); };
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online && !justCameBack) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed z-[60] bottom-4 left-1/2 -translate-x-1/2 px-3 py-2 rounded-sm text-xs font-bold shadow-lg border ${
        online
          ? "bg-[#DCFCE7] border-[#15803D] text-[#15803D]"
          : "bg-[#FEE2E2] border-[#B91C1C] text-[#B91C1C]"
      }`}
      data-testid={online ? "online-restored" : "offline-indicator"}
    >
      <div className="flex items-center gap-2">
        {online ? <Wifi size={14} /> : <WifiOff size={14} />}
        <span>
          {online
            ? "Back online · fresh data loading…"
            : "Offline · showing last-saved data. New entries need internet."}
        </span>
      </div>
    </div>
  );
}
